import { api } from '@/lib/api';
import { queryOptions } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';

export interface WarningPattern {
  id: number;
  name: string | null;
  surname: string | null;
  email: string | null;
  type: boolean; // true = exact match, false = partial match
}

export interface PaginationMeta {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

export interface WarningPatternsResponse {
  data: Array<WarningPattern>;
  links: Record<string, unknown>;
  meta: PaginationMeta;
}

export const getWarningPatternsQuery = (
  page: number = 1,
  perPage: number = 15,
) =>
  queryOptions({
    queryKey: queryKeys.warningPatterns.all(page),
    queryFn: async () => {
      const params = new URLSearchParams();
      params.set('page', page.toString());
      params.set('per_page', perPage.toString());
      const response = await api
        .get(`admin/warning-patterns?${params.toString()}`)
        .json<WarningPatternsResponse>();
      return response;
    },
  });
